/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { sequentialLoaderStates } from "constants/enums";

class SequentialLoader {
  constructor(loadItem, errorHandler) {
    this.loadItem = loadItem;
    this.errorHandler = errorHandler;
    this.state = sequentialLoaderStates.IDLE;
    this.items = [];
  }

  load = (items, priority) => {
    this.items = Array.from(items);
    this.priority = priority;
    return this._run();
  };

  pause = () => {
    this.state = sequentialLoaderStates.PAUSED;
  };

  resume = () => {
    this.state = sequentialLoaderStates.IDLE;
    this._run();
  };

  reset = () => {
    this.items = [];
    this.state = sequentialLoaderStates.IDLE;
    this.loadItem = undefined;
    this.errorHandler = undefined;
  };

  _run = async () => {
    if (this.state !== sequentialLoaderStates.IDLE) {
      return;
    }

    this.state = sequentialLoaderStates.RUNNING;
    while (this.items.length !== 0 && this.state === sequentialLoaderStates.RUNNING) {
      const item = this.items.shift();
      try {
        // eslint-disable-next-line no-await-in-loop
        await this.loadItem(item, this.priority);
      } catch (err) {
        if (this.errorHandler) {
          this.errorHandler(item, err);
        }
      }
    }

    if (this.state === sequentialLoaderStates.RUNNING) {
      this.state = sequentialLoaderStates.IDLE;
    }
  };
}

export { SequentialLoader };
